<template>
  <input
    v-model.trim="modelValue"
    type="text"
  >
</template>

<script>
const countryCode = '+359'

export default {
  name: 'PhoneInput',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    modelValue: {
      get: ({ value }) => value,
      set (value = '') {
        let updatedValue = countryCode
        if (value) {
          updatedValue = value.match(/^0\d{9}$/i)
            ? countryCode + value.substring(1)
            : value
        }
        this.$emit('input', updatedValue)
      }
    }
  }
}
</script>
